import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ManagerYearlyPlanDto } from '../types';

type Params = {
  managerId: number;
  year: number;
  plan: string;
};

export const updateManagerYearlyPlan = async ({ managerId, year, plan }: Params) => {
  const { data } = await api.post<ManagerYearlyPlanDto>(
    `${PANEl_BASE_URL}/general/manager-plan-year/create_by_params/`,
    {
      manager: managerId,
      year,
      plan,
    }
  );

  return data;
};

export const useUpdateManagerYearlyPlan = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: updateManagerYearlyPlan,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
